<div [editableInStoryblok]="_editable()">
	<vp-google-map [lat]="latitude()" [long]="longitude()" />
</div>
